import React from "react";

interface Props {
  categoryName: string;
  parentName?: string;
}
const RelatedCategoryHeader = ({ categoryName, parentName }: Props) => {
  const getHeader = () => {
    if (parentName) {
      const shouldIncludeSupplies =
        !parentName.includes("Equipment") &&
        !parentName.includes("Supplies") &&
        parentName.trimRight().substr(parentName.length - 1) !== "s";

      return `Other ${parentName}${shouldIncludeSupplies ? " Supplies" : ""}`;
    }

    return `Categories Similar to ${categoryName}`;
  };

  return (
    <h2 id="carousel-heading" className="header-3 clears">
      {getHeader()}
    </h2>
  );
};

export default RelatedCategoryHeader;
